import styled from 'styled-components';

export const Refresh = styled.button`
  background-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  color: rgb(0, 125, 184);
  cursor: pointer;
  display: inline;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-weight: 400;
  height: auto;
  line-height: 24px;
  text-align: left;
  text-decoration-color: rgb(0, 125, 184);
  text-decoration-line: none;
  text-decoration-style: solid;
  text-size-adjust: 100%;
  width: auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  border: none;
  &:hover {
    text-decoration: underline;
    color: rgb(0, 73, 108);
  }
`;
